export class HttpErrorModel {
  success: boolean;
  message: string;
}
